/**
 * Socket Connection Wrapper
 *
 * Handles socket.io connection with demo mode support
 */

import socketIOClient from 'socket.io-client';
import { getMockSocket } from './mockSocket';

const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

/**
 * Create socket connection
 * Returns mock socket in demo mode, real socket otherwise
 */
export function createSocketConnection(uri) {
  if (isDemoMode || !uri) {
    console.log('[DEMO MODE] Using mock socket');
    return getMockSocket();
  }

  console.log('[PRODUCTION MODE] Using real socket.io connection');
  return socketIOClient(uri);
}

// Export for direct use
export const socket = createSocketConnection(process.env.REACT_APP_SOCKET_URI || '');
